import { Outlet } from 'react-router-dom';
import { SectionErrorBoundary } from '@/components/SectionErrorBoundary';
import { VideoDetailProvider } from '@/features/video/VideoDetailContext';
import { VideoDrawer } from '@/features/video/VideoDrawer';
import { AddToCanvasPickerProvider } from '@/library/AddToCanvasPicker';
import { TourProvider } from '@/onboarding/TourProvider';
import styles from './AppShell.module.css';
import { BottomNav } from './BottomNav';
import { FreeQuotaBadge } from './FreeQuotaBadge';
import { Header } from './Header';
import { HelpDialog } from './HelpDialog';
import { ShellProvider } from './ShellContext';

/** Оболочка авторизованной части: шапка, страница, мобильная нижняя навигация, окно помощи, онбординг-тур. */
export function AppShell() {
  return (
    <ShellProvider>
      <VideoDetailProvider>
        <AddToCanvasPickerProvider>
          <TourProvider>
            <div className={styles.shell}>
              <Header />
              <main id="main" className={styles.main}>
                <SectionErrorBoundary scope="page">
                  <Outlet />
                </SectionErrorBoundary>
              </main>
              <BottomNav />
              <FreeQuotaBadge />
              <HelpDialog />
              <VideoDrawer />
            </div>
          </TourProvider>
        </AddToCanvasPickerProvider>
      </VideoDetailProvider>
    </ShellProvider>
  );
}
